import { render, staticRenderFns } from "./CorrespondenceYN.vue?vue&type=template&id=09dbbb6a"
import script from "./CorrespondenceYN.vue?vue&type=script&lang=js"
export * from "./CorrespondenceYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports